export default __webpack_public_path__ + "static/media/Optometrist.2ca5115e.svg";